import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { GenericService } from "../../../services/generic.service";
import { GeneralWarningModalComponent } from "../../../components/shared/modals/general-warning-modal/general-warning-modal.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-inline-repeater',
    templateUrl: './inline-repeater.component.html',
    styleUrls: ['./inline-repeater.component.scss'],
    standalone: false
})
export class InlineRepeaterComponent implements OnInit {
  @Input() label: string;
  @Input() disabledFlag: boolean;
  @Input() fields: repeaterField[];
  @Input() initialValues: any;
  @Input() buttonText: string = "Click to edit";
  @Input() deleteWarningTitle = "";
  @Input() deleteWarningMessage = "";
  @Input() deleteWarningQuestion = "";
  @Input() showFieldsUpdated: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() sort: boolean = false;
  @Output() valuesEmitter = new EventEmitter<any>();
  @Output() itemEmitter = new EventEmitter<any>();
  @Output() deleteEmitter = new EventEmitter<any>();
  @Output() editing = new EventEmitter<boolean>();
  values: any;

  tempValue: any;

  editMode = false;
  datePicketActive: boolean=false;

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
      !this.genericService.isDescendant("repeaterContainer", event.target) &&
      !this.genericService.isDescendant("repeaterPreview", event.target) &&
      !this.genericService.isDescendant("mat-option", event.target) &&
      !this.genericService.isDescendant("mat-menu-content", event.target) &&
      !this.genericService.isDescendant("inlineEditorContainer", event.target) &&
      !this.genericService.isDescendant("mat-calendar-controls", event.target) &&
      !this.genericService.isDescendant("mat-calendar-body", event.target) &&
      !this.genericService.isDescendant("weaveSelectOption", event.target) &&
      !this.genericService.isDescendant("mat-mdc-menu-content", event.target) &&
      this.editMode && !this.datePicketActive
    ) {
      this.editMode = false;
      this.editing.emit(this.editMode);
      if(this.sort) {
        this.sortByField1();
      }
    }
  }

  constructor(
    private genericService: GenericService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.values = this.initialValues;
    if(this.sort) {
      this.sortByField1();
    }
    this.tempValue = this.initialValues;
  }
  undo() {
    this.initialValues = this.tempValue;
    //todo make it undo the changes
  }

  setDatePickerActive(value: boolean){
      this.datePicketActive = value;

  }

  sortByField1() {
    if(this.fields[0].type === 'datepicker') {
      return this.values.sort( ( a, b ) => new Date(a[ this.fields[ 0 ].propertyName ]).getTime() - new Date(b[ this.fields[ 0 ].propertyName ]).getTime());
    } else {
      return this.values.sort( ( a, b ) => a[ this.fields[ 0 ].propertyName ].localeCompare( b[ this.fields[ 0 ].propertyName ] ) );
    }
  }

  addRow(){
    let newObj = {};
    for(let field of this.fields){
      newObj[field.propertyName] = "";
    }
    this.values.push(newObj);
    this.valuesEmitter.emit(this.values);
    this.itemEmitter.emit(newObj);
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    this.editing.emit( this.editMode );
  }

  removeRow(index: number){
    if( this.deleteWarningTitle ){
      const dialogRef = this.dialog.open( GeneralWarningModalComponent, {
        width: '600px',
        data: {
          title: this.deleteWarningTitle,
          message: this.deleteWarningMessage,
          question: this.deleteWarningQuestion,
          cancelText: "Do not delete",
          confirmText: "Delete",
          isPlainMessage: false
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          const removed = this.values.splice(index, 1);
          this.valuesEmitter.emit(this.values);
          this.deleteEmitter.emit(removed);
        }
      });
    } else {
      const removed = this.values.splice(index, 1);
      this.valuesEmitter.emit(this.values);
      this.deleteEmitter.emit(removed);
    }
  }

  updateDate(i, key, $event){
    if(this.values[i][key] !== $event) {
      this.values[ i ][ key ] = $event;
      this.valuesEmitter.emit( this.values );
    }
  }

  emitValues(i, key, $event){
    if(this.values[i][key] !== $event) {
      this.values[ i ][ key ] = $event;
      this.valuesEmitter.emit( this.values );
    }
  }

}

export interface repeaterField{
  label: string,
  type: string,
  propertyName: string,
  selectValues?: {
    label: string,
    value: any
  }[]

}

